import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { AuctionAlertType } from '../AuctionAlert';
import { BidResult } from './BidResultEnum';

export const bidResultMap = {
  [BidResult.HOLD_SEAT]: {
    type: AuctionAlertType.INFO,
    icon: <CheckIcon />,
    message: 'You currently hold a seat at',
  },
  [BidResult.PENDING_SEAT]: {
    type: AuctionAlertType.WARN,
    icon: <PriorityHighIcon />,
    message: 'Your bid is pending on payment completion.',
  },
  [BidResult.PROCESSING]: {
    type: AuctionAlertType.WARN,
    icon: <PriorityHighIcon />,
    message: 'Your bid is processing.',
  },
  [BidResult.AUCTION_CLOSING]: {
    type: AuctionAlertType.WARN,
    icon: <PriorityHighIcon />,
    message: 'Auction closed - processing bids',
  },
  [BidResult.OUT_BID]: {
    type: AuctionAlertType.WARN,
    icon: <PriorityHighIcon />,
    message: 'You were out-bid.',
  },
  [BidResult.SUCCESSFUL]: {
    type: AuctionAlertType.SUCCESS,
    icon: <CheckIcon />,
    message: 'Your bid was successful!',
  },
  [BidResult.UNSUCCESSFUL]: {
    type: AuctionAlertType.ERROR,
    icon: <CloseIcon />,
    message: 'Your bid was unsuccessful!',
  },
};
